import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import TechnicalViewContainer from "./TechnicalViewContainer";

export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.VISUALIZATIONS],
  };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles}>
      <TechnicalViewContainer />
    </App>
  );
};
